module.exports = __webpack_public_path__ + "static/media/logo-git.0b819d63.svg";